// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82631f60","577":"87f13a66","625":"6d603e22","797":"c1371c12","928":"b498aed6"}[chunkId] + ".chunk.js";
};